import { Link } from 'react-router-dom';
import { Badge } from '../../../design-system/components/Badge';
import { Card } from '../../../design-system/components/Card';
import type { SearchHit } from '../api';

interface SearchResultItemProps {
  hit: SearchHit;
}

function formatDuration(startMs: number): string {
  const total = Math.floor(startMs / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}

export function SearchResultItem({ hit }: SearchResultItemProps) {
  return (
    <Card>
      <article className="dash-search__item">
        <header className="dash-search__item-header">
          <Link
            to={`/meetings/${hit.meeting_id}?segment=${hit.segment_id}`}
            className="dash-search__item-title"
          >
            {hit.meeting_title ?? 'Reunião sem título'}
          </Link>
          <Badge variant={hit.speaker === 'closer' ? 'accent' : 'neutral'}>
            {hit.speaker === 'closer' ? 'Closer' : 'Cliente'}
          </Badge>
          <span className="muted">@ {formatDuration(hit.start_ms)}</span>
        </header>
        {hit.closer_name !== null ? <span className="label">{hit.closer_name}</span> : null}
        {/* Snippet vem HTML-escapado pelo backend com <mark> ao redor do
            termo. Seguro para dangerouslySetInnerHTML — sanitização
            validada em tests/test_f5b_meetings_search.py. */}
        <p
          className="dash-search__item-snippet"
          dangerouslySetInnerHTML={{ __html: hit.snippet }}
        />
      </article>
    </Card>
  );
}
